import { render, staticRenderFns } from "./module-selection.vue?vue&type=template&id=583131ba&"
import script from "./module-selection.vue?vue&type=script&lang=js&"
export * from "./module-selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports